<template>
  <BasicModal
    :title="'ユーザーの追加'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="set-container">
      <b-field :label="$t('Setting.email')">
        <b-input v-model="addEmail"
                type="email"
                icon="email"
                >
        </b-input>
      </b-field>
      <b-field :label="$t('Setting.username')">
        <b-input v-model="addName"
                icon="account"
                >
        </b-input>
      </b-field>
      <b-field label="ユーザー権限">
        <b-select placeholder="権限を選択"
                  v-model="addPermission">
            <option
              v-for="(s, index) in select"
              :value="index"
              :key="index">
              {{ s }}
            </option>
        </b-select>
      </b-field>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" :disabled="!isMailCheck" @click="sendEmail()">追加する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    BasicModal
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      addEmail: '',
      addName: '',
      addPermission: 0,
      select: [
        '管理者',
        '編集者',
        '閲覧者',
        'ログイン不可'
      ],
    }
  },
  watch: {
    isShowModal () {
      this.addEmail = '',
      this.addName = '',
      this.addPermission = 0
    }
  },
  computed: {
    isMailCheck () {
      if (this.addEmail.match(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    sendEmail () {
      this.sendControlLog('ユーザー一覧　ユーザー追加', 'ユーザーの追加モーダルにて、「追加する」ボタンをクリックした。')
      // 表示
      const isChatNotify = this.addPermission < 3 ? true : false
      // ストア未分類の表示可否
      const isStoreOther = this.addPermission < 3 ? true : false

      this.$emit('sendEmail', {
        email: this.addEmail,
        username: this.addName,
        permission: this.addPermission,
        is_notify: false,
        is_chat_enable: isChatNotify,
        is_store_other: isStoreOther,
        is_client: true,
        is_user: false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.set-container {
  padding: 24px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Setting/organisms/ModalCreateUser.vue